import { rest } from 'msw'

export default [
  /**
   * シンプル記録
   */
  rest.get('/swc-api/nodes/:nodeId/maintenance-histories', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "アニオン槽の膜交換作業",
        "detail": "定期メンテナンス作業。\r\n\r\n作業開始時間 10:00〜15:00 \r\n作業担当者：XXX \r\n\r\n作業完了後に、現場担当者にXXを確認し、問題ないことを確認"
        },
        {
        "id": 2,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "カチオン槽の膜交換作業",
        "detail": "定期メンテナンス作業。\r\n\r\n作業開始時間 10:00〜15:00 \r\n作業担当者：XXX \r\n\r\n作業完了後に、現場担当者にXXを確認し、問題ないことを確認"
        }
        ]),
    )
  }),

  /**
   * シンプル記録
   */
   rest.get('/swc-api/nodes/:nodeId/maintenance-histories/:technicalReportId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json(
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "アニオン槽の膜交換作業",
        "detail": "定期メンテナンス作業。\r\n\r\n作業開始時間 10:00〜15:00 \r\n作業担当者：XXX \r\n\r\n作業完了後に、現場担当者にXXを確認し、問題ないことを確認"
        })
    )
  }),

  /**
   * シンプル記録
   */
   rest.post('/swc-api/nodes/:nodeId/maintenance-histories/', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json(
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "アニオン槽の膜交換作業",
        "detail": "定期メンテナンス作業。\r\n\r\n作業開始時間 10:00〜15:00 \r\n作業担当者：XXX \r\n\r\n作業完了後に、現場担当者にXXを確認し、問題ないことを確認"
        })
    )
  }),

  /**
   * シンプル記録
   */
   rest.put('/swc-api/nodes/:nodeId/maintenance-histories/:maintenanceHistoryId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json(
        {
        "id": 1,
        "node_id": 4,
        "node_name": "SaiForce",
        "date": "2022-02-24",
        "title": "アニオン槽の膜交換作業",
        "detail": "定期メンテナンス作業。\r\n\r\n作業開始時間 10:00〜15:00 \r\n作業担当者：XXX \r\n\r\n作業完了後に、現場担当者にXXを確認し、問題ないことを確認"
        })
    )
  }),

    /**
   * シンプル記録
   */
     rest.delete('/swc-api/nodes/:nodeId/maintenance-histories/:maintenanceHistoryId', (req, res, ctx) => {
      // If authenticated, return a mocked user details
      return res(
        ctx.status(200),
        ctx.json(
          {
          "id": 1,
          "node_id": 4,
          "node_name": "SaiForce",
          "date": "2022-02-24",
          "title": "アニオン槽の膜交換作業",
          "detail": "定期メンテナンス作業。\r\n\r\n作業開始時間 10:00〜15:00 \r\n作業担当者：XXX \r\n\r\n作業完了後に、現場担当者にXXを確認し、問題ないことを確認"
          })
      )
    }),
]
